import { useLanguage } from "../../../../../stores/LanguageStore";
import { useState } from "react";
import { ActionIcon, Button, Tooltip } from "@mantine/core";
import {
  IconMailStar,
  IconMessageStar,
  IconStar,
  IconStarFilled,
  IconStars,
  IconStarsFilled,
} from "@tabler/icons-react";
import { updateProspect } from "../../../../../api/PRMAPI";
import {
  useLeadsContainerStore,
  useLeadsSheetStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";

const MarkAsNewConversation = ({
  current,
  closeMenu,
  containerId,
  inSheet,
  isMobile,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const setNewsCount = useLeadsStore((s) => s.setNewsCount);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const updateContainerItem = useLeadsContainerStore(
    (s) => s.updateContainerItem
  );

  const handleClick = () => {
    setLoading(true);
    return updateProspect({
      id: current.id,
      new_first_reply: true,
      new_reply: true,
    })
      .then(() => {
        setLoading(false);
        closeMenu?.();
        if (inSheet) {
          updateContainerItem(currentContainer?.id, current.id, {
            new_first_reply: true,
            new_reply: true,
          });
          setCurrent({ ...current, new_first_reply: true });
        } else {
          updateContainerItem(containerId, current.id, {
            new_first_reply: true,
            new_reply: true,
          });
        }
        if (current?.new_reply === false) {
          setNewsCount(useLeadsStore.getState().newsCount + 1);
        }
      })
      .finally(() => setLoading(false));
  };

  if (inSheet) {
    if (isMobile) {
      return (
        <Button
          variant="light"
          color="primary"
          px={"sm"}
          onClick={handleClick}
          loading={loading}
        >
          <IconMessageStar size={18} />
        </Button>
      );
    }
    return (
      <Tooltip label={lang.prm.mark_as_new_conversation}>
        <ActionIcon
          onClick={handleClick}
          variant={current?.new_first_reply ? "filled" : "light"}
          size={38}
          radius={"xl"}
          loading={loading}
        >
          <IconMessageStar size={22} />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Button
      onClick={handleClick}
      variant="subtle"
      loading={loading}
      leftSection={<IconMessageStar size={18} />}
      justify="start"
    >
      {lang.prm.mark_as_new_conversation}
    </Button>
  );
};

export default MarkAsNewConversation;
